import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
import { ParamsClean } from '@/common/decorators/params-clean'
import type { PatchInfo } from '@/views/dashboard/safe-status/vulnerability-fix/vulnerability-fix.service'

export interface QueryParams {
  /** 页码 */
  page: number
  /** 每页数量 */
  limit: number
}

export interface IgnoreItem {
  /** 补丁编号 */
  kb_number: string
  /** 补丁描述 */
  kb_desc: string
  /** 补丁发布日期 */
  kb_pub_date: string
  /** 漏洞类型 */
  leak_type: string
  /** 漏洞级别 */
  warn_level: number
  /** 补丁大小 */
  size: string
  /** 操作系统 */
  os: string
  /** 悬停补丁详情缓存（与漏洞列表行一致） */
  patch_info?: PatchInfo
}
@Injectable()
export class IgnoreService {
  constructor (private http: Http) {}

  @ParamsClean()
  getLeakIgnores (data: QueryParams) {
    return this.http.post<{
      /** 忽略漏洞列表 */
      list: IgnoreItem[]
      /** 总数 */
      total: number
    }>('/leak/ignore-view/get', data)
  }

  cancelLeakIgnore (data: { kb_numbers: string[] }) {
    return this.http.post<void>('/leak/ignore-cancel', data)
  }
}

